<template>
  <div class="container-simple-table">
    <div class="header-table">
      <div class="search-container">
        <feather
          class="refreshtable"
          :class="loadingtable === true ? 'animation-refresh' : 'stop'"
          type="refresh-cw"
          size="18px"
          @click="
            (!loadingtable) ? $emit('update-table', { offset: 0, limit: rowsperpage}) : null"
        />
        <search
          width="100%"
          height="35px"
          @searchtext="searchTerm = $event"
        />
      </div>
      <div class="left-side-container">
        <div class="select-rows-qt">
          <select
            v-model="rowsperpagechange"
            class="select-container"
            @change="$emit('change-rows', {
              status,
              orderby: shortOptions.orderby,
              direction: shortOptions.direction,
              offset: (lastpage * rowsperpagechange) - rowsperpagechange,
              rowsperpage: rowsperpagechange
            })"
          >
            <option :value="10">
              10 Linhas -
              {{ `${userPageStatus} Até ${rowsperpageCustom}` }}
            </option>
            <option :value="30">
              30 Linhas -
              {{ `${userPageStatus} Até ${rowsperpageCustom}` }}
            </option>
            <option :value="50" selected>
              50 Linhas -
              {{ `${userPageStatus} Até ${rowsperpageCustom}` }}
            </option>
            <option :value="100">
              100 Linhas -
              {{ `${userPageStatus} Até ${rowsperpageCustom}` }}
            </option>
          </select>
        </div>
        <Export :data="data" :filters="status" />
        <s-filter @filter="filter($event)" />
      </div>
    </div>

    <b-table
      :data="isEmpty ? [] : data"
      :selected.sync="selected"
      pagination-size="is-small"
      focusable
      :paginated="isEmpty === false ? true : false"
      backend-pagination
      :total="total"
      striped
      :backend-sorting="true"
      :per-page="rowsperpage"
      :current-page="currentPage"
      :loading="loadingtable"
      @sort="(name, action) => changeShort(name, action)"
      @page-change="changeShort(shortOptions.orderby, shortOptions.direction ,$event)"
    >
      <b-table-column
        v-slot="props"
        field="acoes"
        label="Ações"
        width="40"
        centered
        header-class="custom-header"
      >
        <b-dropdown aria-role="list">
          <h1 slot="trigger" class="row-actions-circles">
            <div class="circle" />
            <div class="circle" />
            <div class="circle" />
          </h1>

          <b-dropdown-item aria-role="listitem" @click="$router.push(`list/${props.row.id}`)">
            <div class="menu-row-option">
              <feather class="menu-row-icon check" type="check" size="16" />
              <h1>Ver Detalhes</h1>
            </div>
          </b-dropdown-item>
          <b-dropdown-item aria-role="listitem" @click="$router.push(`edit/${props.row.id}`)">
            <div class="menu-row-option">
              <feather class="menu-row-icon check" type="edit" size="16" />
              <h1>Editar</h1>
            </div>
          </b-dropdown-item>
          <b-dropdown-item aria-role="listitem" @click="$emit('editaction', {
            selected:props.row,
            limit: rowsperpage,
            offset: 0,
          })"
          >
            <div class="menu-row-option">
              <feather class="menu-row-icon danger" type="trash" size="16" />
              <h1>Desativar</h1>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="id"
        label="ID"
        width="40"
        numeric
        centered
        sortable
        header-class="custom-header"
      >
        <h1 :ref="'a' + props.row.id" class="table-title-cad id">
          {{ props.row.id }}
        </h1>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="usuario"
        label="Usuário"
        header-class="custom-header"
        sortable
      >
        <h1 class="table-title-cad user">
          {{ props.row.usuario }}
        </h1>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="email"
        label="Email"
        header-class="custom-header"
        sortable
      >
        <span class="table-title-cad email">
          {{ props.row.email ? props.row.email : '~' }}
        </span>
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="status"
        label="Status"
        header-class="custom-header"
        sortable
      >
        <tag :state="props.row.status" :data="props.row.status === 1 ? 'Ativo' : 'Inativo'" />
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="integracao_id"
        label="Integração Id"
        header-class="custom-header"
        sortable
      >
        <span class="table-title-cad int-id">
          {{ props.row.integracao_id ? props.row.integracao_id : '~' }}
        </span>
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="created_at"
        label="Data de Criação"
        header-class="custom-header"
        sortable
      >
        <span class="table-title-cad int-id">
          {{ props.row.created_at ? dateTimeToBrasil(props.row.created_at) : '~' }}
        </span>
      </b-table-column>
    </b-table>
    <Empty
      v-if="data.length <= 0 && loadingtable === false"
      message="Nenhum item encontrado"
      subtitle="Tente alterar os filtros"
    />
  </div>
</template>

<script>
import sFilter from '../filter/simple';
import search from '../search/index';
import tag from '../tags/situation';
import Export from '../miscellaneous/exportusr';
import Empty from '../empty';
import global from '../../../mixins/global';

export default {
	components: {
		search,
		sFilter,
		tag,
		Empty,
		Export,
	},
	mixins: [global],
	props: {
		currentPage: {
			type: Number,
			default: 1,
		},
		total: {
			type: Number,
			default: 0,
		},
		rowsperpage: {
			type: Number,
			default: 50,
		},
		data: {
			type: Array,
			default: () => [],
		},
		loadingtable: {
			type: Boolean,
			default: true,
		},
		labels: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			rowsperpagechange: 50,
			rowsperpageCustom: 50,
			userPageStatus: 1,
			lastpage: 1,
			shortOptions: { orderby: 'created_at', direction: 'desc' },
			pageRows: 0,
			isBordered: false,
			selected: {},
			isStriped: false,
			isNarrowed: false,
			isHoverable: false,
			isFocusable: false,
			isLoading: false,
			searchTerm: '',
			status: null,
		};
	},
	computed: {
		isEmpty() {
			if (this.data.length <= 0) {
				return true;
			}
			return false;
		},
	},
	watch: {
		selected(e) {
			this.$nextTick(() => {
				this.focustTable(`a${e.id}`);
			});
		},
		searchTerm(e) {
			const params = {
				status: this.status,
				orderby: this.shortOptions.orderby,
				direction: this.shortOptions.direction,
				offset: 0,
				limit: this.rowsperpage
			};
			if (e) {
				this.$emit('searchtext', {
					...params,
					searchTerm: e,
				});
			} else {
				this.$emit('searchtext', {
					...params,
					searchTerm: ''
				});
			}
		},
	},
	methods: {
		focustTable(refId = 'a139') {
			this.$refs[refId].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
		},
		filter(params) {
			this.$emit('filtertable', {
				...params,
				offset: (this.lastpage * this.rowsperpagechange) - this.rowsperpagechange,
				page: this.lastpage,
				orderby: this.shortOptions.orderby,
				direction: this.shortOptions.direction,
			});
		},
		changeShort(orderby, direction, page) {
			const offset = (this.lastpage * this.rowsperpagechange) - this.rowsperpagechange;
			this.lastpage = page;
			this.rowsperpageCustom = page * this.rowsperpagechange + 1;
			this.userPageStatus = this.rowsperpageCustom - this.rowsperpagechange;
			let filterDate = {};
			if (localStorage.getItem('filter-users')) {
				filterDate = JSON.parse(localStorage.getItem('filter-users'));
			}
			this.shortOptions.orderby = orderby;
			this.shortOptions.direction = direction;
			const dados = {
				offset,
				limit: this.rowsperpage,
				page: this.lastpage,
				...filterDate,
				orderby: this.shortOptions.orderby,
				direction: this.shortOptions.direction,
			};
			this.$emit('change-order', dados);
		},
		showmodal() {
			this.$emit('editaction', this.selected);
		},
	},
};
</script>

<style lang="scss" scoped>
.disabled {
  cursor: not-allowed !important;
}
.dropdown-menu {
  font-size: 12px !important;
}
.circle {
  width: 5px;
  height: 5px;
  margin: 1px;
  border-radius: 50%;
  background-color: rgb(212, 212, 212);
  transition: ease-in-out 0.5s;
}
.row-actions-circles {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.row-actions-circles:hover {
  cursor: pointer;
}
.row-actions-circles:hover .circle {
  background-color: rgb(139, 139, 139);
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  transition: 0.5s ease-in-out;
}

.empty p {
  color: #25213b;
  font-weight: bold;
}
.img-empty {
  width: 35%;
}

.search-container {
  width: 60%;
  display: flex;
  align-items: center;
}

.refreshtable {
  margin-right: 20px;
  color: #00c9a7;
  cursor: pointer;
}

.animation-refresh {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.container-simple-table {
  margin-bottom: 20px;
  background-color: #fff;
  padding: 13px;
  border-radius: 5px;
}

.left-side-container {
  display: flex;
  height: 35px;
}
.select-container {
  all: unset;
  width: 150px;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 20px;
  border: 1px solid #e2e2e2;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 15px;
  font-size: 12px;
  color: rgb(98, 98, 98);
}

.span-rounded {
  width: 50px;
  height: 50px;
  background-color: #25213b;
}
.header-table {
  display: flex;
  width: 100%;
  background-color: #fff;
  justify-content: space-between;
  padding: 20px;
}

.about-more {
  font-size: 12px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 5px;
  color: #6e6893;
  font-weight: normal;
}

.int-id,
.email,
.user,
.id {
  font-size: 12px;
  font-weight: 400;
  color: #626262;
}

.table-title-cad {
  display: flex;
  color: $row-color;
  font-weight: $row-weight;
  margin-top: 5px;
  margin-bottom: 2px;
  font-size: $row-size;
}

.custom-header {
  font-size: $header-size;
  font-weight: $header-weight;
  color: $header-color;
}

.is-success {
  display: flex;

  align-items: center;
}

.menu-row-icon {
  color: #8b83ba;

  padding-left: 10px;

  padding-right: 10px;

  font-weight: 500;
}

.menu-row-box-bottom {
  padding-top: 10px;
}

.menu-row-box {
  padding-bottom: 10px;

  border-bottom: 1px solid #f2f0f9;
}

.menu-row-option:first-child {
  margin-top: 5px;
}

.menu-row-option:hover {
  color: #25213b !important;
  border-radius: 5px;
}

.menu-row-option:hover .danger {
  color: #dc3545 !important;
}

.menu-row-option:hover .check {
  color: #007f00;
}

.menu-row-option:hover .archive {
  color: #f77f00;
}

.menu-row-option {
  display: flex;

  align-items: center;

  margin-left: 5px;

  margin-right: 5px;

  padding: 10px;

  cursor: pointer;
}
</style>
>
